module.exports = __webpack_public_path__ + "assets/fonts/Gordita-Medium.8a27e6a50f0dfc242b936fefcd353e7e.woff";